export default {
  "title": {
    "evolution": "At risk (evolution)",
    "distribution": "Fatigue rates histogram",
    "indicators": "Main fatigue indicators",
    "ranking": "Driver’s Ranking"
  },
  "labels": {
    "driversAtRisk": "Drivers at risk (daily evolution)",
    "driversAtRiskKpi": "Drivers at risk",
    "filterByRisk": "Filter by risk"
  },
  "selects": {
    "All": "All",
    "HasRisk": "At risk"
  },
  "buttons": {
    "moreDetails": "More details"
  },
  "graphToolTip": {
    "HasRisk": "At risk",
    "indice": "Rate between",
    "drivers": "drivers"
  },
  "nfa": {
    "previousPeriod": "Last period",
    "thisPeriod": "This period",
    "to": "to",
    "underRisk": "Under complete risk",
    "driverNfa": "It represents the percentage of drivers / day with their level of fatigue accumulated in 4 selected periods of time",
    "nfaText": "Level of accumulated fatigue: it is an indicator that calculates the probability of occurrence of at least one drowsiness event in a work day within the next 24 hours. There are 4 levels of accumulated fatigue, classified according to the probability of suffering an drowsiness event:",
    "percentageOfNfaOne": "0% to 2% of suffering an drowsiness event on the next shift",
    "percentageOfNfaTwo": "2% to 10% of suffering an drowsiness event on the next shift",
    "percentageOfNfaThree": "10% to 20% of suffering an drowsiness event on the next shift",
    "percentageOfNfaFour": "20% a 100% of suffering an drowsiness event on the next shift",
    "howItGoes": "How you are doing regarding the goal",
    "goal": "Goal",
    "Deviations": "Generated deviations",
    "distribution": "Deviation distribution",
    "deviationQuantity": "Number of deviations",
    "managmentQuantity": "Number of managements for the",
    "managmentQuantityTime": "Number of in-time managements",
    "driverRanking": "Driver’s Ranking",
    "rankinNunber": "Ranking number",
    "driverName": "Driver’s name",
    "riskPeriod": "Period risk",
    "evoulutionRisk": "Evolution percentage of the level of risk fatigue level",
    "fatigueLevel": "Accumulated fatigue level",
    "titleMain": "Evolution accumulated fatigue level in all operations"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/english/fatigue/detailFatigue.js